'use strict';

angular.module('shiftTraderApp')
    .controller('RequestsCtrl', function ($scope, trades, me, Session, ShiftTradesResource, daysOffRequests) {
      $scope.trades = _.invoke(trades, '$initialize');
      $scope.daysOffRequests = daysOffRequests;
      $scope.me = me;

      var calculateActiveState = function() {
        // these are active & accepted trades!!
        $scope.activeTrades = _.filter($scope.trades, function(trade) {
          return trade.$calculateActive(true) && trade.$isAccepted();
        });

        $scope.inactiveTrades = _.filter($scope.trades, function(trade) {
          return !trade.$calculateActive(true) && (trade.$isDisapproved() || trade.$isApproved());
        });
      };

      calculateActiveState();
      ShiftTradesResource.query({active: false}, function(data) {
        $scope.trades.push.apply($scope.trades, _.invoke(data, '$initialize'));
        calculateActiveState();
      });

      $scope.currentList = $scope.activeTrades;
      $scope.showSelector = 'true';

      $scope.nowDate = moment().tz(Session.getTimezone());
      _.forEach($scope.trades, function(trade) {
        trade.created_at_tz = moment.utc(trade.created_at).tz(Session.getTimezone());
        trade.timeAgo = trade.created_at_tz.twix($scope.nowDate);
      });

      _.forEach($scope.daysOffRequests, function(dor) {
        dor.created_at_tz = moment.utc(dor.created_at).tz(Session.getTimezone());
        dor.timeAgo = dor.created_at_tz.twix($scope.nowDate);
      });

      $scope.setShow = function(val) {
        if (val === 'true') {
          $scope.currentList = $scope.activeTrades;
        } else {
          $scope.currentList = $scope.inactiveTrades;
        }
        $scope.showSelector = val;
      };
    });
